import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { DeviceAwareComponent } from './device-aware-component';
import { QuestionsService } from '@APP/services/questions-service';
import { DepInjMixin, requires } from '@APP/mixins/dependency';
import { RedCrossIcon } from '../icons/icons';
import { eventBus } from '@APP/utils/event-bus';
import { Events } from '@APP/events/app-events';
import { uploadImageBaseStyles } from '@APP/styles/uploadImage';

type Deps = {
  questionsService: QuestionsService;  
};

@requires(QuestionsService.serviceName)
@customElement('lh-image-upload-button-error')
export class LHImageUploadButtonError extends DepInjMixin<Deps>(DeviceAwareComponent) {

  static get baseStyles() {
    return [uploadImageBaseStyles];
  }

  static get mobileStyles() {
    return [css``];
  }
  static get desktopStyles() {
    return [css``];
  }
  static get rtlStyles() {
    return [css` :host { text-align: right; } `];
  }
  static get ltrStyles() {
    return [css` :host { text-align: left; } `];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
  }
  
  renderContent() {
    return html`
        <div class="upload-container">
          <div class="icon upload-info">${RedCrossIcon}</div>
          <div class="drag-text"> Oops! the file format is not supported</div>
          <button class="upload-button" @click="${() => eventBus().emit(Events.Type.PopupClose)}">Try again</button>
        </div>
        `;
  }
}
